const REFERRAL_CODE = 'referralCode'
const APP_PROVIDER = 'appProvider'
const APP_USER_ID = 'appUserId'

const setReferralCode = (referralCode) => {
  try {
    localStorage.setItem(REFERRAL_CODE, referralCode)
  } catch (e) {
    console.error(e)
  }
}

const getReferralCode = () => {
  return localStorage.getItem(REFERRAL_CODE) || ''
}

const removeReferralCode = () => {
  localStorage.removeItem(REFERRAL_CODE)
}

const setAppProvider = (value) => {
  try {
    localStorage.setItem(APP_PROVIDER, value)
  } catch (e) {
    console.error(e)
  }
}

const getAppProvider = () => {
  return localStorage.getItem(APP_PROVIDER) || ''
}

const removeAppProvider = () => {
  localStorage.removeItem(APP_PROVIDER)
}

const setAppUserId = (value) => {
  try {
    localStorage.setItem(APP_USER_ID, value)
  } catch (e) {
    console.error(e)
  }
}

const getAppUserId = () => {
  return localStorage.getItem(APP_USER_ID) || ''
}

const removeAppUserId = () => {
  localStorage.removeItem(APP_USER_ID)
}

export {
  setReferralCode,
  getReferralCode,
  removeReferralCode,
  setAppProvider,
  getAppProvider,
  removeAppProvider,
  setAppUserId,
  getAppUserId,
  removeAppUserId
}
